let ctx = null;
let active = null;
let blipTimer = null;

const blip = () => {
  if (!ctx) return;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "sine";
  osc.frequency.value = 1240;
  gain.gain.setValueAtTime(0.0001, ctx.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.035, ctx.currentTime + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.35);
  osc.connect(gain).connect(ctx.destination);
  osc.start();
  osc.stop(ctx.currentTime + 0.4);
};

export const startAmbience = () => {
  if (active) return;
  ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();

  const length = ctx.sampleRate * 2;
  const buffer = ctx.createBuffer(1, length, ctx.sampleRate);
  const data = buffer.getChannelData(0);
  let last = 0;
  for (let i = 0; i < length; i++) {
    const white = Math.random() * 2 - 1;
    last = (last + 0.02 * white) / 1.02;
    data[i] = last * 3.5;
  }
  const noise = ctx.createBufferSource();
  noise.buffer = buffer;
  noise.loop = true;
  const lowpass = ctx.createBiquadFilter();
  lowpass.type = "lowpass";
  lowpass.frequency.value = 220;
  const humGain = ctx.createGain();
  humGain.gain.value = 0.05;
  noise.connect(lowpass).connect(humGain).connect(ctx.destination);
  noise.start();

  blipTimer = setInterval(blip, 3600);
  active = { noise, humGain };
};

export const stopAmbience = () => {
  if (blipTimer) {
    clearInterval(blipTimer);
    blipTimer = null;
  }
  if (active) {
    try {
      active.noise.stop();
    } catch (e) {}
    active.humGain.disconnect();
    active = null;
  }
};
